import { Link, useLocation } from 'react-router-dom';
import { Tv, Calendar, Trophy, FileText, Menu, X } from 'lucide-react';
import { useState } from 'react';

export const Layout = ({ children }) => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { path: '/', label: 'Jogos', icon: Calendar },
    { path: '/resultados', label: 'Resultados', icon: Trophy },
    { path: '/templates', label: 'Templates', icon: FileText },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-pitch-black noise-overlay relative">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-pitch-black/95 backdrop-blur-md border-b border-zinc-800">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link 
              to="/" 
              className="flex items-center gap-2 group"
              data-testid="logo-link"
            >
              <Tv className="w-6 h-6 text-neon-green" />
              <span className="font-heading text-xl md:text-2xl font-bold uppercase tracking-tight">
                Onde <span className="text-neon-green">Assistir</span>
              </span>
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-1">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-2 px-4 py-2 text-sm font-medium uppercase tracking-wider transition-colors ${
                    isActive(item.path)
                      ? 'text-neon-green border-b-2 border-neon-green'
                      : 'text-zinc-400 hover:text-white'
                  }`}
                  data-testid={`nav-${item.label.toLowerCase()}`}
                >
                  <item.icon className="w-4 h-4" />
                  {item.label}
                </Link>
              ))}
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 text-zinc-400 hover:text-white"
              data-testid="mobile-menu-btn"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Nav */}
        {mobileMenuOpen && (
          <nav className="md:hidden bg-card-dark border-t border-zinc-800">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`flex items-center gap-3 px-4 py-4 text-sm font-medium uppercase tracking-wider border-b border-zinc-800/50 ${
                  isActive(item.path)
                    ? 'text-neon-green bg-pitch-black/50'
                    : 'text-zinc-400'
                }`}
              >
                <item.icon className="w-5 h-5" />
                {item.label}
              </Link>
            ))}
          </nav>
        )}
      </header>

      {/* Main Content */}
      <main className="max-w-6xl mx-auto px-4 py-6 md:py-8">
        {children}
      </main>

      {/* Footer */}
      <footer className="border-t border-zinc-800 mt-auto">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-zinc-500">
            <p>Informações de transmissão de jogos de futebol</p>
            <p>As informações podem mudar sem aviso prévio</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
